import { IconBot } from '@developerz/ui';
import type { JSX } from 'solid-js';
import { t } from '../i18n';
import { orgHref } from '../lib/org';
import { OrgSwitcher } from './OrgSwitcher';

// The funnel's own chrome. `AppShell` strips the sidebar and topbar on
// `/onboarding`, and the org switcher lives in the sidebar — so from inside the
// wizard there was no way to see, let alone change, WHICH account you were
// onboarding. Prod carries three orgs and four user accounts; a person with more
// than one is the majority case, not the edge.
export function OnboardingBrand(props: { readonly token: string | null }): JSX.Element {
  return (
    <div class="onboarding__brand-row">
      <a class="app-brand" href={orgHref('/')}>
        <span class="app-brand__mark" aria-hidden="true">
          <IconBot size="1.25rem" />
        </span>
        <span class="app-brand__text">
          <span class="app-brand__name">{t('app.title')}</span>
          <span class="app-brand__sub">{t('app.subtitle')}</span>
        </span>
      </a>
      <OrgSwitcher token={props.token} />
    </div>
  );
}
